import type { FC } from 'react'

import type { SelectOption } from '@/components/Select'
import Select from '@/components/Select'

export enum AgeOfReference {
  ALL = 'all',
  TODAY = 'today',
  ONE_DAY_OLD = 'oneDayOld',
  TWO_DAYS_OLD = 'twoDaysOld',
  THREE_DAYS_OLD = 'threeDaysOld',
  FOUR_DAYS_OLD = 'fourDaysOld',
  FIVE_DAYS_OLD = 'fiveDaysOld',
  MORE_THAN_FIVE_DAYS_OLD = 'moreThanFiveDaysOld',
}

export type Filter = AgeOfReference

const selectOptions: SelectOption<AgeOfReference>[] = [
  {
    label: 'All',
    value: AgeOfReference.ALL,
  },
  {
    label: 'Today',
    value: AgeOfReference.TODAY,
  },
  {
    label: '1 day old',
    value: AgeOfReference.ONE_DAY_OLD,
  },
  {
    label: '2 days old',
    value: AgeOfReference.TWO_DAYS_OLD,
  },
  {
    label: '3 days old',
    value: AgeOfReference.THREE_DAYS_OLD,
  },
  {
    label: '4 days old',
    value: AgeOfReference.FOUR_DAYS_OLD,
  },
  {
    label: '5 days old',
    value: AgeOfReference.FIVE_DAYS_OLD,
  },
  {
    label: 'Older than 5 days',
    value: AgeOfReference.MORE_THAN_FIVE_DAYS_OLD,
  },
]

export const DEFAULT_FILTER: Filter = AgeOfReference.ALL

interface Props {
  filter: Filter
  onChangeFilter: (filter: Filter) => void
}

const AgeOfReferenceFilter: FC<Props> = ({ filter, onChangeFilter }) => (
  <Select
    ariaLabel="Age of reference"
    selectedValue={filter}
    onSelect={onChangeFilter}
    options={selectOptions}
  />
)

export default AgeOfReferenceFilter
